<h2 mat-dialog-title>ACORD Licensing Notice</h2>

<mat-dialog-content>
  <p>
    ACORD is now requiring you to also purchase a license directly from them. If you are a member of the National
    PIA or the IIABA, the new ACORD license may already be available to you. For more information on ACORD
    licensing, please contact ACORD at (845) 620-1700 or by visiting <a
       href="https://www.ACORD.org/forms-pages/forms-participation-programs">https://www.ACORD.org/forms-pages/forms-participation-programs</a>.
  </p>
  <br />
  <p>
    THIS PRODUCT INCORPORATES LICENSED COPYRIGHTED AND OTHER PROPRIETARY MATERIAL OF ACORD CORPORATION, INCLUDING
    ACORD STANDARDIZED FORMS. ACORD FORMS ARE LICENSED BY ACORD, NOT SOLD.YOU ACKNOWLEDGE AND AGREE THAT YOU MUST BE
    PARTY TO A WRITTEN LICENSE AGREEMENT DIRECTLY WITH ACORD CORPORATION IN ORDER TO USE THE ACORD FORMS CONTAINED
    IN THIS PRODUCT AND REPRESENT AND WARRANT THAT YOU WILL OBTAIN SUCH A LICENSE PRIOR TO USING ACORD FORMS.
    NEITHER THE PROVIDER OF THIS PRODUCT, NOR ANY THIRD PARTY, CAN GRANT LICENSES TO USE ACORD FORMS. YOU CAN OBTAIN
    A LICENSE AGREEMENT PERMITTING YOU AND YOUR USERS TO USE ACORD FORMS, WHICH MAY REQUIRE YOU TO PAY FEES TO
    ACORD, BY CONTACTING ACORD AT +1-845- 620-1700 OR THROUGH THE ADDITIONAL CONTACT INFORMATION AVAILABLE AT
    WWW.ACORD.ORG.
  </p>
  <p>
    ACORD FORMS ARE MODIFIED PERIODICALLY TO REFLECT CHANGING LEGAL, INDUSTRY AND OTHER REQUIREMENTS. THE ACORD
    FORMS CONTAINED IN THIS PRODUCT MAY NOT BE THE MOST CURRENT MATERIALS THAT ACORD PUBLISHES.
  </p>
  <p>
    USING OUTDATED ACORD FORMS MAY BE PROHIBITED IN CERTAIN CASES BY GOVERNMENT REGULATORS AND INCREASES THE RISK OF
    LEGAL ACTION BY INSUREDS AND OTHER THIRD PARTIES.
  </p>
  <p>
    IT IS SOLELY YOUR RESPONSIBILITY TO CONFIRM THAT YOU ARE USING ONLY THE MOST CURRENT FORMS THAT ACORD PUBLISHES.
    YOU MAY DETERMINE THE CURRENCY OR NON-CURRENCY OF ACORD FORMS BY CONSULTING THE FORMS INFORMATION SECTION OF
    ACORD'S WEBSITE (WWW.ACORD.ORG).
  </p>
  <p>
    ACORD is an intended third party beneficiary of the above provisions. The above provisions are made expressly
    for the benefit of, and are enforceable by, ACORD. The name ACORD and the ACORD logo are registered marks of
    ACORD Corporation.
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  @if (!user.supportPersonId) {
    <button type="button"
            mat-button
            color="primary"
            [mat-dialog-close]="true">Accept</button>
  } @else {
    <button type="button"
            mat-button
            color="primary"
            mat-dialog-close>Dismiss</button>
  }
</mat-dialog-actions>